/* jslint browser: true */
/* global document window */
import React, { Component } from 'react';
import axios from 'axios';
import validator from 'validator';
import { toast } from 'react-toastify';
import { apiUrl } from '../lib/constants.js';

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '', // contient le nouveau mot de passe
            hash: '', // contient le hash de l'utilisateur
            error: '' // contient les erreurs affichées
        };
    }

    componentWillMount() {
        this.setState({ hash: this.props.match.params.hash });
        axios
            .get(`${apiUrl}/api/v1${window.location.pathname}`)
            .then(response => {})
            .catch(err => {
                window.location.href = '/login?h';
            });
    }

    /**
     * Affecte les valeurs des input du formulaire au State
     */
    handleChangeForm() {
        const pass1 = document.querySelector('#password1').value;
        const pass2 = document.querySelector('#password2').value;
        if (pass1 !== pass2) {
            this.setState({ error: 'Les mots de passe sont differents' });
            return false;
        }
        this.setState({
            password: pass1,
            error: ''
        });
        return true;
    }

    /**
     * Récupère et envoie les données du formulaire, et envoie la requete de reset de mot de passe
     * @param  {Event} e - Evenement du click sur le bouton
     */
    handleResetPassword(e) {
        e.preventDefault();
        if (validator.isEmpty(this.state.password)) {
            toast.error('Les mots de passe ne corespondent pas');
            return;
        }
        if (!validator.isLength(this.state.password, 6)) {
            toast.error('Mot de passe trop court');
            return;
        }
        if (this.handleChangeForm()) {
            axios
                .post(`${apiUrl}/api/v1/login/reset`, {
                    hash: this.state.hash,
                    pass: this.state.password
                })
                .then(response => {
                    window.location.href = '/login?o';
                })
                .catch(err => {});
        }
    }

    render() {
        return (
            <div className="login-wrapper">
                <form>
                    <div>
                        <label className="full-width" htmlFor="password1">
                            Mot de passe
                            <br />
                            <input
                                required
                                className="text-center"
                                type="password"
                                name="password1"
                                id="password1"
                                onChange={() => this.handleChangeForm()}
                            />
                        </label>
                        <label className="full-width" htmlFor="password2">
                            Confirmer
                            <br />
                            <input
                                required
                                className="text-center"
                                type="password"
                                name="password2"
                                id="password2"
                                onChange={() => this.handleChangeForm()}
                            />
                        </label>
                    </div>
                    <div
                        className={
                            this.state.error === ''
                                ? 'fadeOut errors'
                                : 'fadeIn errors'
                        }
                    >
                        <p>{this.state.error}</p>
                    </div>
                    <div>
                        <button
                            className="btn myBtn"
                            onClick={e => this.handleResetPassword(e)}
                        >
                            Valider
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/ResetPassword.js